import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import createSyarahV2Fetcher from "@/common/fetchSyarahv2";

//TODO: add correct sources

var mapScenarioTextToScenario = function mapScenarioTextToScenario(scenario_text) {
  switch (scenario_text) {
    case "login":
      return 2;
    case "signup":
      return 4;
    case "update_phone":
      return 3;
  }
};
export var api__verifyOtp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var source, phone_number, otp, scenario_text, _ref$full_name, full_name, _ref$city_id, city_id, order_id, is_finance, cart_id, params, responseData;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          source = _ref.source, phone_number = _ref.phone_number, otp = _ref.otp, scenario_text = _ref.scenario_text, _ref$full_name = _ref.full_name, full_name = _ref$full_name === void 0 ? '' : _ref$full_name, _ref$city_id = _ref.city_id, city_id = _ref$city_id === void 0 ? '' : _ref$city_id, order_id = _ref.order_id, is_finance = _ref.is_finance, cart_id = _ref.cart_id;
          params = {
            phone_number: phone_number,
            otp: otp,
            scenario: mapScenarioTextToScenario(scenario_text)
          };
          full_name && (params["full_name"] = full_name);
          city_id && (params["city_id"] = city_id);
          order_id && (params["order_id"] = order_id);
          is_finance && (params["is_finance"] = is_finance);
          cart_id && (params["cart_id"] = cart_id);
          _context.n = 1;
          return createSyarahV2Fetcher({
            throwValidationException: true
          }).post("/auth/otp-verify?source=".concat(source), params);
        case 1:
          responseData = _context.v;
          return _context.a(2, responseData.data.data);
      }
    }, _callee);
  }));
  return function api__verifyOtp(_x) {
    return _ref2.apply(this, arguments);
  };
}();